import { rem } from 'polished'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { getImageUrl } from 'lib/image/imageUtils'
import { usePlaceImages } from 'tripPlanner/hooks/Google/usePlaceImages'
import { ItemMetadata } from 'tripPlanner/models'
import { TripItem } from 'tripPlanner/types/tripItem'
import { getItemPlace } from 'tripPlanner/utils'

const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: ${rem(8)};
  gap: ${rem(10)};
  background-color: ${props => props.theme.palette.neutral.default.six};
  width: ${rem(36)};
  height: ${rem(36)};
`

const Image = styled.img`
  object-fit: cover;
  object-position: center;
  width: ${rem(36)};
  height: ${rem(36)};
`

interface Props {
  item: TripItem
  imgSrc?: string
  imgId?: string
  placeId?: string
}

export const CuratedProductImage = ({
  item,
  imgId,
  imgSrc,
  placeId,
}: Props) => {
  const Icon = ItemMetadata[item.type].icon
  const place = getItemPlace(item, 'start')

  let imageElement: React.ReactNode
  const placeHolderImage = (
    <ImageContainer>
      <Icon />
    </ImageContainer>
  )

  const imageUrlFromImgId = useMemo(
    () =>
      imgId ?
        getImageUrl(imgId, {
          width: 72,
          height: 72,
          format: 'jpeg',
          quality: 'low',
        }) :
        undefined,
    [imgId],
  )

  const { data: images } = usePlaceImages(
    {
      placeId: placeId ?? '',
      maxWidthPx: 72,
      tripId: item.tripId,
      tripItemId: item.id,
    },
    {
      enabled: !imgId && !!placeId,
    },
  )

  const imageSrc =
    imgSrc ?? imageUrlFromImgId ?? images?.[0]?.url ?? place?.photoUrl

  if (imageSrc) {
    imageElement = <Image src={imageSrc} />
  } else {
    imageElement = placeHolderImage
  }

  return imageElement
}
